import { render } from "./IconBalloonPresentBox.vue?vue&type=template&id=96b93240"
import script from "./IconBalloonPresentBox.vue?vue&type=script&lang=js"
export * from "./IconBalloonPresentBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__